import { render, staticRenderFns } from "./swiperBanner.vue?vue&type=template&id=a9ac1582&scoped=true&"
import script from "./swiperBanner.vue?vue&type=script&lang=ts&"
export * from "./swiperBanner.vue?vue&type=script&lang=ts&"
import style0 from "./swiperBanner.vue?vue&type=style&index=0&id=a9ac1582&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ac1582",
  null
  
)

export default component.exports